module.exports = {"previous":"前一页","next":"下一个 &raquo;"};